 <script>
    import {getContext} from 'svelte';
    import {HeroForm} from '../store.js';
    const {url} = getContext('APP');
    let changeClr = 'before';
    let changeClr2 = 'before';
    let changeClr3 = 'before';
    const formNo = Object.fromEntries(new URLSearchParams($url.search));
    const technicalSkillOptions = [
        'Non-Technical',
        'Novice',
        'Proficient',
        'Expert',
    ];
    const englishAbilityOptions = [
        'no-English',
        'Beginner',
        'Intermediate',
        'Upper-Intermediate',
        'Advanced',
    ];
    const industryOptions = [
        'Blockchain',
        'Longevity',
        'Space',
        'Artificial Intelligence',
        'Other',
    ];
    const formData = {
        technicalSkill: '',
        englishAbility: '',
        industry: '',
        industryOther: '',
    };
    if (HeroForm.get() != undefined) {
        formData.technicalSkill = HeroForm.get().technicalSkill;
        formData.englishAbility = HeroForm.get().englishAbility;
        formData.industry = HeroForm.get().industry;
        formData.industryOther = HeroForm.get().industryOther;
    }
    $: if (HeroForm.get() != undefined) {
        HeroForm.update((n)=> n={session: HeroForm.get().session, name: HeroForm.get().name, email: HeroForm.get().email,
            country: HeroForm.get().country, countryCode: HeroForm.get().countryCode,
            city: HeroForm.get().city, phoneNumber: HeroForm.get().phoneNumber, dateOfBirth: HeroForm.get().dateOfBirth,
            gender: HeroForm.get().gender,
            technicalSkill: formData.technicalSkill, englishAbility: formData.englishAbility,
            industry: formData.industry, industryOther: formData.industryOther,
            business: HeroForm.get().business, visa: HeroForm.get().visa,
            aid: HeroForm.get().aid, referalName: HeroForm.get().referalName,
            hearAbout: HeroForm.get().hearAbout, hearAboutOthers: HeroForm.get().hearAboutOthers,
            startup: HeroForm.get().startup,
            aboutYourSelf: HeroForm.get().aboutYourSelf,
            portfolioURL: HeroForm.get().portfolioURL, buildingPlan: HeroForm.get().buildingPlan,
            travelBudget: HeroForm.get().travelBudget, buildingWeeks: HeroForm.get().buildingWeeks,
            invitedtoProgram: HeroForm.get().invitedtoProgram, ackowledged: HeroForm.get().ackowledged});
    }
    /**
     *
     * @param {string}object
     */
    function SaveData() {
        if (formNo.name === 'HeroTraining') {
            location.href='/apply?name=HeroTraining&FormNo=forthform';
        } else if (formNo.name === 'KanooInnovationHub') {
            location.href='/apply?name=KanooInnovationHub&FormNo=forthform';
        } else if (formNo.name === 'HouseOfCeek') {
            location.href='/apply?name=HouseOfCeek&FormNo=forthform';
        }
    }
    /**
     *
     *
     */
    function goBack() {
        if (formNo.name === 'HeroTraining') {
            location.href='/apply?name=HeroTraining&FormNo=secondform';
        } else if (formNo.name === 'KanooInnovationHub') {
            location.href='/apply?name=KanooInnovationHub&FormNo=secondform';
        } else if (formNo.name === 'HouseOfCeek') {
            location.href='/apply?name=HouseOfCeek&FormNo=secondform';
        }
    }
    $: if (formData.technicalSkill != '') {
        changeClr = 'chclr';
    }
    $: if (formData.englishAbility != '') {
        changeClr2 = 'chclr';
    }
    $: if (formData.industry != '') {
        changeClr3 = 'chclr';
    }
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<div class="desktop">
    <div class="back-div">
        <div>
            <div class="process">
                <p>Process</p>
            </div>
            <div class="process_x">
                <p>
                    Our Application is a 4 step process, where you provied the
                    requierd information. This form costs $5 for submission.
                </p>
            </div>
        </div>
        <ul style="list-style: none;">
            {#each Array(4) as _, i}
                <li class="vl" />
            {/each}
        </ul>
        <div class="front-div">
            <div>
                <div class="back-arrow" on:click={() => ( goBack())}>
                    <img src="images/apply/back_arrow.svg" alt="">
                </div>
                <form on:submit|preventDefault={SaveData}>
                    <div>
                        <div style="display:flex;">
                            <div style="margin-left: 4.96vw;">
                                <label for="skills">Level of Technical Skill</label>
                                <div>
                                    <select
                                        class = "clr {changeClr}"                                       
                                        bind:value={formData.technicalSkill}
                                        required
                                        >
                                        <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                                        {#each technicalSkillOptions as option}
                                            <option value={option}>
                                                {option}
                                            </option>
                                        {/each}  
                                    </select>
                                </div>
                            </div>

                            <div style="margin-left: 2.646vw;">
                                <label for="ability">Level of English Ability</label>
                                <div>
                                    <select
                                        class = "clr {changeClr2}"  
                                        bind:value={formData.englishAbility}
                                        required
                                    >
                                    <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                                        {#each englishAbilityOptions as option}
                                            <option value={option}>
                                                {option}
                                            </option>
                                        {/each} 
                                    </select>
                                </div>
                            </div>
                        </div>

                            <div style="margin-left: 4.96vw;">
                                <label for="industry">Industry</label>
                                <div>
                                    <select
                                        class = "clr {changeClr3}"  
                                        bind:value={formData.industry}
                                        required
                                    >
                                    <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                                        {#each industryOptions as option}
                                            <option value={option}>
                                                {option}
                                            </option>
                                        {/each} 
                                    </select>
                                </div>
                            </div>
                        

                        <div style="display:flex;">
                            <div style="margin-left: 4.96vw;">
                                <label for="others"
                                    >If you listed “Other” for industry, please write your industry below</label
                                >

                                <div>
                                    <input
                                        type="text"
                                        id="others"
                                        placeholder="Please Select"
                                        style="width: 18.915vw;margin-top: 0.397vw;"
                                        bind:value={formData.industryOther}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style="margin-left: 5vw; margin-top: 5vw;">
                            <button
                                style=" background-color: rgba(60, 116, 192, 1);
                                        border-radius: 1.984vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 1.190vw;"
                               >Next</button
                            >
                        </div> 
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="mobile">
    <div class="back-div-mobile">
        <div>
            <div class="process-mobile">
                <p>Process</p>
            </div>
            <div class="process_x-mobile">
                <p>
                    Our Application is a 4 step process, where you provied the
                    requierd information. This form costs $5 for submission.
                </p>
            </div>
        </div>
        <div style="margin-top: -6vw;">
            <ul
            style="list-style: none; display: flex; justify-content: space-around;  margin-left: -2vw; width: 100vw;"
        >
            {#each Array(4) as _, i}
                <li class="vl-mobile" />
            {/each}
        </ul>
        </div>
        <div class="front-div-mobile">
            <form on:submit|preventDefault={SaveData}>
                <div>
                    <div>
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">Level of Technical Skill</p>
                            <div style="margin-top: 0.529vw;">
                                <select
                                    class = "select-mobile {changeClr}"                                       
                                    bind:value={formData.technicalSkill}
                                    required
                                    >
                                    <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                                    {#each technicalSkillOptions as option}
                                        <option value={option}>
                                            {option}
                                        </option>
                                    {/each}  
                                </select>
                            </div>
                        </div>
    
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">Level of English Ability</p>
                            <div style="margin-top: 0.529vw;">
                                <select
                                    class = "select-mobile {changeClr2}"  
                                    bind:value={formData.englishAbility}
                                    required
                                >
                                <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                                    {#each englishAbilityOptions as option}
                                        <option value={option}>
                                            {option}
                                        </option>
                                    {/each} 
                                </select>
                            </div>
                        </div>
    
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">Industry</p>
                            <div style="margin-top: 0.529vw;">
                                <select
                                    class = "select-mobile {changeClr3}"  
                                    bind:value={formData.industry}
                                    required
                                >
                                <option style="color: rgba(171, 171, 171, 1);" value="" disabled selected>Please Select</option>
                                    {#each industryOptions as option}
                                        <option value={option}>
                                            {option}
                                        </option>
                                    {/each} 
                                </select>
                            </div>
                        </div>
    
                        <div style="margin-left: 8.333vw;">
                            <p class="p-mobile">
                                If you listed “Other” for industry, please write
                                your industry below
                            </p>
    
                            <div>
                                <input
                                    class="input-mobile"
                                    style="width: 71.0vw;"
                                    type="text"
                                    id="others"
                                    placeholder="Please Select"
                                    bind:value={formData.industryOther}
                                />
                            </div>
                        </div>
                    </div>
                    <div style="margin-left: 8vw; margin-top: 5vw;  display: flex; gap: 4.673vw;">
                        <button
                            style=" background-color: rgba(60, 116, 192, 1);
                            border-radius: 6.069vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 3.889vw;"
                           >Next</button>
                        <div class="back-arrow-mob" on:click={() => ( goBack())}>
                            <img src="images/apply/back_button.svg" alt="">
                        </div> 
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<style>
    option{
        color:  black;
    }
    .clr{
        width: 18.915vw; 
        margin-top: 0.397vw;
    }
    .before{
        color: rgba(171, 171, 171, 1);
    }
    .chclr{
        color: black;
    }
     .back-arrow{
        width: 1.72vw;
        height: 0.926vw;
        margin-left: 2.646vw;
        margin-bottom: -1vw;
        margin-top: 1.323vw;
        cursor: pointer;
    }
    .back-arrow img{
        width: 100%;
        height: 100%;
    }
    .back-div {
        position: relative;
        height: 44.812vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 2vw;
        display: flex;
        margin-bottom: -1.1vw;
        margin-top: 1.1vw;
    }
    .front-div {
        position: absolute;
        width: 100%;
        height: 38.294vw;
        background: #ffffff;
        border-bottom-left-radius: 2vw;
        border-bottom-right-radius: 2vw;
        left: 22.25vw;
        bottom: 6.8vw;
    }

    .process {
        font-size: 1.984vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 3vw;
        margin-top: 4.497vw;
    }
    .process_x {
        width: 15.013vw;
        font-size: 0.926vw;
        color: rgb(255 255 255);
        font-weight: 300;
        margin-left: 3vw;
    }
    .vl {
        margin-top: 1.984vw;
        border-radius: 0.5vw;
        width: 0.463vw;
        border-left: 0.5vw solid rgba(60, 116, 192, 1);
        height: 5.82vw;
        opacity: 0.3;
        margin-left: 0vw;
    }
    .vl:nth-child(3) {
        border-left: 0.5vw solid white;
        opacity: 100;
    }
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("images/dropdown.svg");
        background-repeat: no-repeat;
        background-position-x: 17.4vw;
        background-position-y: 1vw;
        background-size: 0.6vw;
    }
    input {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        font-size: 0.926vw;
    }
    input::placeholder {
        font-size: 0.926vw;
    }
    label {
        font-size: 1.058vw;
        margin-top: 1.984vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 700;
    }
    select {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        background-color: transparent;
        font-size: 0.926vw;
    }
    .back-div-mobile {
        position: relative;
        height: 168vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 8vw;
        border-top-right-radius: 8vw;
        margin-bottom: -0.5vw;
    }

    .process-mobile {
        font-size: 5.556vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 7.222vw;
        padding-top: 9.167vw;
    }
    .process_x-mobile {
        width: 73.889vw;
        font-size: 3.056vw;
        color: rgb(255 255 255);
        margin-left: 7.222vw;
    }
    .front-div-mobile {
        position: absolute;
        padding-bottom: 5vw;
        top: 45vw;
        background: #ffffff;
        border-top-left-radius: 4.5vw;
        border-bottom-left-radius: 4.5vw;
        left: 7.222vw;
    }
    .vl-mobile {
        border-radius: 0.5vw;
        border-left: 1.3vw solid rgba(60, 116, 192, 1);
        height: 15.460999999999999vw;
        opacity: 0.3;
        margin-left: 0vw;
        transform: rotate(90deg);
    }
    .vl-mobile:nth-child(3) {
        border-left: 1.3vw solid white;
        opacity: 100;
    }
    .input-mobile {
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 1.661vw;
        padding-left: 5.5vw;
        height: 9.111vw;
    }
    .p-mobile {
        font-size: 3.056vw;
        margin-top: 6.667vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 700;
    }
    .select-mobile {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url(images/dropdown.svg);
        background-repeat: no-repeat;
        background-position-x: 43.3vw;
        background-position-y: 3vw;
        background-size: 3.7vw;
    }
    .select-mobile {
        width: 50.0vw;
        border: 0.556vw solid rgba(171, 171, 171, 1);
        border-radius: 1.661vw;
        padding-left: 5.5vw;
        height: 9.111vw;
        background-color: transparent;
    }
    .desktop {
        display: block;
        width: 100%;
        overflow: hidden;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .back-arrow-mob{
            width: 10.047vw;
            height: 7.243vw;
        }
        .back-arrow-mob img{
            width: 100%;
            height: 100%;
        }
        input {
            font-size: 3.187vw;
        }
        input::placeholder {
            font-size: 3.187vw;
        }
        select {
            font-size: 3.187vw;
        }
    }
</style>
